module.exports = __webpack_public_path__ + "static/wallpaper_design_award_2017-6514cf85aef72f0a329a570eff71aa09.png";